// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"bcc35970","609":"ce8a5b7c","625":"28975508","649":"d0a4a1d3","652":"4527f782","674":"c317bba5","863":"65cdc241","872":"c10278dc","900":"5f89728a"}[chunkId] + ".chunk.js";
};